import { axios } from '@/utils/request'

/**
 * 查询列表
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function nursingPage (parameter) {
  return axios({
    url: '/buNurseRecord/getBuNurseRecords',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询预约记录详情
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function nursingDetial (parameter) {
  return axios({
    url: '/buNurseAssessment/getBuNurse',
    method: 'get',
    params: parameter
  })
}

/**
 * 更新预约记录
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function nursingUpdate (parameter) {
  return axios({
    url: '/buNurseRecord/updateBuNurseRecord',
    method: 'post',
    params: parameter
  })
}


/**
 * 获取科室
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function nursingDept (parameter) {
  return axios({
    url: '/dept/getDeptList',
    method: 'get',
    params: parameter
  })
}

//
/**
 * 根据科室获取医生
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function nursingDoct (parameter) {
  return axios({
    url: '/userBasic/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 更新预约记录
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function whetherAcceptOrder(parameter) {
  return axios({
    url: '/buNurseRecord/updateBuNurseRecord',
    method: 'post',
    params: parameter
  })
}

/**
 * 获取预约汇总表数据
 * @param parameter
 * @returns {AxiosPromise}
 */
export function getNurseStatisticsSummary (parameter) {
  return axios({
    url: '/buNurseRecord/getNurseStatisticsSummary',
    method: 'get',
    params: parameter
  })
}